/* eslint-disable prettier/prettier */
// src/modules/owner/pages/actions/tanqueCheio/sections/prize.jsx

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import MaterialGrid from '@material-ui/core/Grid';
import { Field, reduxForm, getFormValues, change as changeField } from 'redux-form';
import { connect } from 'react-redux';
import { InputLabelOutlined } from 'common/components/fields/InputLabelOutlined';
import PrimaryButton from 'common/components/buttons/primaryButton';
import SecondaryButton from 'common/components/buttons/secondaryButton';
import GenericConfirmationCard from 'common/components/cards/genericConfirmationModel/genericConfirmationModel';
import { thousandSeparatorMask, currencyMask } from 'helpers/masks';
import { FORM_RULES } from 'helpers/validations';
import { LimitByAudienceField } from '../../sections/LimitByAudienceField';
import { TANQUE_CHEIO_TYPE_ID } from '../constants';
import { isMobile } from 'react-device-detect';

const Prize = (props) => {
  const {
    handleSubmit,
    auth,
    formValues,
    changeField,
    activeActions,
    general,
    disabled,
    onClickProgress,
    openConfirmation,
    handleCancelClose,
    setOpenConfirmation,
    buttonConfirmationLabel,
    confirmationTitle,
    confirmationSubtitle,
    prevClick,
    closeModal,
  } = props;

  const now = new Date();
  const isDisabled =
    disabled ||
    (formValues &&
      !formValues.is_tanque_cheio &&
      !formValues.is_draft &&
      now > new Date(formValues.end));

  // recalcula total de vouchers disponíveis sempre que os dois campos mudam
  useEffect(() => {
    // converte "1.000" ou "1.000,00" em número bruto
    const rawAvailable = String(formValues.available_liters || '')
      .replace(/\./g, '')
      .replace(/,/g, '.');
    const rawPerVoucher = String(formValues.liters_per_voucher || '')
      .replace(/\./g, '')
      .replace(/,/g, '.');

    const available = parseFloat(rawAvailable) || 0;
    const perVoucher = parseFloat(rawPerVoucher) || 0;
    const total = perVoucher > 0 ? Math.floor(available / perVoucher) : '';

    changeField('tanqueCheioForm', 'total_vouchers_available', total);
  }, [formValues.available_liters, formValues.liters_per_voucher, changeField]);

  const onSubmit = (values) => {
    values.submitFromButton = true;

    if (props.handleNativeChange) {
      const currentValue = props.value || 2;
      const nextValue = currentValue + 1;
      props.handleNativeChange(null, nextValue);
    } else {
      console.log('Props.value:', props.value);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div
        style={{
          overflowY: 'auto',
          height: isMobile ? 'calc(100vh - 250px)' : 'calc(100vh - 355px)',
          overflowX: 'hidden',
          paddingRight: isMobile ? 0 : 15,
        }}>
        {/* 1) Estoque e Vouchers */}
        <Typography
          variant="subtitle2"
          style={{
            fontSize: 16,
            fontWeight: 400,
            marginTop: 20,
            marginBottom: 8,
          }}>
          Vouchers
        </Typography>
        <MaterialGrid item xs={12}>
          <Field
            component={InputLabelOutlined}
            label="Litros por voucher"
            name="liters_per_voucher"
            validate={[FORM_RULES.required]}
            disabled={isDisabled}
            required
            margin="normal"
            {...thousandSeparatorMask}
          />
        </MaterialGrid>
        {/* <MaterialGrid item xs={12}>
          <Field
            component={InputLabelOutlined}
            label="Total de vouchers disponíveis"
            name="total_vouchers_available"
            disabled
            margin="normal"
            {...thousandSeparatorMask}
          />
        </MaterialGrid> */}
        <MaterialGrid item xs={12}>
          <Field
            component={InputLabelOutlined}
            label="Vouchers por cliente"
            name="vouchers_per_client"
            validate={[FORM_RULES.required]}
            disabled={isDisabled}
            required
            margin="normal"
            {...thousandSeparatorMask}
          />
        </MaterialGrid>
        <LimitByAudienceField
          auth={auth}
          formValues={formValues}
          isDisabled={isDisabled}
          typeId={TANQUE_CHEIO_TYPE_ID}
        />

        {/* 3) Preço por Litro */}
        <Typography
          variant="subtitle2"
          style={{
            fontSize: 16,
            fontWeight: 400,
            marginTop: 20,
            marginBottom: 8,
          }}>
          Preço por Litro
        </Typography>
        {/* <MaterialGrid item xs={12}>
          <Field
            component={InputLabelOutlined}
            label="Preço bruto do litro"
            name="gross_price_per_liter"
            validate={[FORM_RULES.required]}
            disabled={isDisabled}
            required
            margin="normal"
            {...currencyMask}
          />
        </MaterialGrid> */}
        {/* <MaterialGrid item xs={12}>
          <Field
            component={InputLabelOutlined}
            label="Subsídio por litro"
            name="subsidy_per_liter"
            validate={[FORM_RULES.required]}
            disabled={isDisabled}
            required
            margin="normal"
            {...currencyMask}
          />
        </MaterialGrid> */}
        <MaterialGrid item xs={12}>
          <Field
            component={InputLabelOutlined}
            label="Preço do litro"
            name="net_price_per_liter"
            validate={[FORM_RULES.required]}
            disabled={isDisabled}
            required
            margin="normal"
            {...currencyMask}
          />
        </MaterialGrid>

        <GenericConfirmationCard
          open={openConfirmation}
          cancelClose={handleCancelClose}
          labelLeftButton="Continuar aqui"
          labelRightButton={buttonConfirmationLabel}
          title={confirmationTitle}
          text={confirmationSubtitle}
          general={general}
          maxWidthFixed
          confirmButtonColor="primary"
          onClose={() => setOpenConfirmation(false)}
          onClick={closeModal}
        />
      </div>

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mt={2}
        style={{ paddingRight: isMobile ? 0 : 29 }}>
        <SecondaryButton
          type="button"
          onClick={prevClick}
          style={{
            width: '48%',
            padding: '10px 20px',
            textTransform: 'none',
          }}>
          Voltar
        </SecondaryButton>
        <PrimaryButton
          type="submit"
          color="primary"
          disabled={activeActions.buttonLoading || isDisabled}
          style={{
            width: '48%',
            padding: isMobile ? '12px 20px' : '10px 20px',
            textTransform: 'none',
            fontSize: isMobile ? 12 : undefined,
          }}>
          Salvar e continuar
        </PrimaryButton>
      </Box>
    </form>
  );
};

Prize.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  formValues: PropTypes.object,
  changeField: PropTypes.func.isRequired,
  activeActions: PropTypes.shape({
    buttonLoading: PropTypes.bool,
  }).isRequired,
  general: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  onClickProgress: PropTypes.func.isRequired,
  openConfirmation: PropTypes.bool.isRequired,
  handleCancelClose: PropTypes.func.isRequired,
  setOpenConfirmation: PropTypes.func.isRequired,
  buttonConfirmationLabel: PropTypes.string,
  confirmationTitle: PropTypes.string,
  confirmationSubtitle: PropTypes.string,
  prevClick: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  formValues: getFormValues('tanqueCheioForm')(state) || {},
  activeActions: state.activeActions,
  general: state.general,
});

const mapDispatchToProps = {
  changeField,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: 'tanqueCheioForm',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  })(Prize)
);
